// import React from "react";
// import ProductCard from "./ProductCard";

// const Products = Array.from({ length: 8 });

// const ProductGrid = () => {
//   return (
//     <div className="grid grid-cols-4 gap-6">
//       {Products.map((_, i) => (
//         <ProductCard key={i} />
//       ))}
//     </div>
//   );
// };

// export default ProductGrid;


// import React from "react";
// // import { useProducts } from "../../hooks/useProducts";
// import ProductCard from "./ProductCard";

// const ProductGrid = ({ products, loading }) => {
//   // const { products, loading, brands } = useProducts(filters);

//   if (loading) {
//     return <p className="text-center">Loading products...</p>;
//   }

//   if (!products.length) {
//     return (
//       <p className="text-center text-gray-500">
//         No products found
//       </p>
//     );
//   }

//   return (
//     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//       {products.map((product) => (
//         <ProductCard key={product._id} product={product} />
//       ))}
//     </div>
//   );
// };

// export default ProductGrid;

import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ products, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="h-[360px] bg-gray-100 rounded-lg animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (!products.length) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-gray-500">
        <p className="text-lg font-medium">
          No products found
        </p>
        <p className="text-sm">
          Try adjusting filters
        </p>
      </div>
    );
  }

  return (
    <div className="
      grid
      grid-cols-2
      sm:grid-cols-2
      md:grid-cols-3
      lg:grid-cols-3
      xl:grid-cols-4
      2xl:grid-cols-5
      gap-6
    ">
      {products.map((product) => (
        <ProductCard key={product._id} product={product} />
      ))}
    </div>
  );
};

export default ProductGrid;
